import React, {
	Dispatch,
	FC,
	SetStateAction,
	useCallback,
	useEffect,
	useState,
} from "react";
import { ReactComponent as CloseWindow } from "../../../../Assets/closeProfileMenu.svg";
import DataHeaderType from "../../../../Types/DataHeaderType";
import { Link, useLocation } from "react-router-dom";
import { observer } from "mobx-react-lite";
import AuthStore from "../../../../Store/AuthStore";
import * as ST from "../../../../Components/Atoms/NavigationMenu/MobileMenu/styled";
import ExitWindow from "../../../../Components/Organisms/ModalWindows/Exit";

type ListMobileNavigationProps = {
	data: DataHeaderType[];
	open?: boolean;
	onClose: Dispatch<SetStateAction<boolean>>;
};

const MobileMenu: FC<ListMobileNavigationProps> = observer(
	({ data, open, onClose }) => {
		const location = useLocation();
		const [windowExit, setWindowExit] = useState<boolean>(false);

		useEffect(() => {
			if (open) {
				document.body.style.overflow = "hidden";
			} else {
				document.body.removeAttribute("style");
			}
		}, [open]);

		const Item: FC<DataHeaderType> = ({ path, name }) => (
			<ST.ItemWrapper
				change={location.pathname === `/${path}`}
			>
				<ST.Item change={location.pathname === `/${path}`}>{name}</ST.Item>
			</ST.ItemWrapper>
		);

		const onClick = useCallback(() => {
			onClose(false);
		}, [onClose]);

		return (
			<ST.ListMobileNavigation
				open={open}
			>
				<ST.MenuClose>
					<CloseWindow onClick={() => onClose(false)} />
				</ST.MenuClose>

				{data.map(({ id, path, name }) => (
					<ST.ItemNavigation key={id}>
						<Link
							to={path}
							onClick={onClick}
						>
							<Item
								id={id}
								path={path}
								name={name}
							>
							</Item>
						</Link>
					</ST.ItemNavigation>
				))}
				<ST.ItemNavigation>
					<ST.ItemWrapper>
						<ST.Item onClick={() => setWindowExit(true)}>Выйти</ST.Item>
					</ST.ItemWrapper>
				</ST.ItemNavigation>
				{windowExit && (
					<ExitWindow
						handleClick={() => setWindowExit(false)}
						accept={() => AuthStore.logout()}
						open
					/>
				)}
			</ST.ListMobileNavigation>
		);
	}
);

export default MobileMenu;
